import { environment } from './environment';
import { Environment } from './environment.type';

export function environmentFactory(): Environment {
  const currentUrl = window.location.hostname;
  const env = { ...environment };

  if (!env.production) {
    if (currentUrl.includes('tmdigital-stag')) {
      env.apiUrl = 'https://tmdigital-api-stag.terramagna.com.br';
    }

    if (currentUrl === 'localhost' || currentUrl === 'app-staging.tmdigital.ag') {
      env.tmPanel = 'https://risk-staging.tmdigital.ag';
      env.loginURL = 'https://login-staging.tmdigital.ag';
    }
  }

  if (env.production) {
    if (currentUrl.includes('tmdigital.terramagna')) {
      env.apiUrl = 'https://tmdigital-api.terramagna.com.br';
    }

    if (currentUrl === 'app.tmdigital.ag') {
      env.tmPanel = 'https://risk.tmdigital.ag';
      env.loginURL = 'https://login.tmdigital.ag';
    }
  }

  return env;
}
